import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
// Components
import { cn } from '@repo/zolintra-utils';
import { Button } from '../../atoms/Button/Button';
// Styles
import styles from './FilterBlock.module.css';

export function FilterBlock({
  children, onClose, closeLabel, isOpen, className,
}) {
  return (
    createPortal(
      <div className={cn([styles['filters-wrapper'], isOpen ? styles.show : ''])}>
        <div role="presentation" className={styles.layer} onClick={onClose} />

        <aside className={cn([styles.filter, isOpen && styles.open, className])}>
          <Button
            className={styles.action}
            onClick={onClose}
            color="transparent"
          >
            <span className="font-bold">
              {closeLabel}
            </span>
          </Button>

          <div className={styles.content}>
            {children}
          </div>
        </aside>
      </div>,
      document.body,
    )
  );
}

FilterBlock.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  closeLabel: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

FilterBlock.defaultProps = {
  className: '',
};

export default FilterBlock;
